import React from 'react';
import Icon from '../../../globalcomponents/Icon';
import {
  CreatedByContainer,
  EventHeader,
  TourComponent,
  TourSuccessfulEventContainer
} from './styles.chatcomponents';
import moment from 'moment';
import { SenderInitial } from '../styles.inboxv2';
import SyncIcon from '../../../Media/InboxV1/SyncIcon';

const TourBookingSuccessfulEvent = ({ props }) => {
  const TourBookingSuccessfulEventprops = props.props;
  const { meta, timeStamp } = TourBookingSuccessfulEventprops;
  const eventHeader = 'Tour booking successful';
  return (
    <TourComponent>
      <TourSuccessfulEventContainer>
        <EventHeader>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px',
              color: '#FFFFFF !important'
            }}
          >
            <Icon src="event-tour-successful-header.svg" />
            <div>{eventHeader}</div>
          </div>

          <div className="nunito-10px-400" style={{ padding: '5px 0' }}>
            <Icon src="sync-icon-white.svg" />
          </div>
        </EventHeader>
      </TourSuccessfulEventContainer>

      <CreatedByContainer>
        <div style={{ padding: '5px 0' }}>
          {moment(TourBookingSuccessfulEventprops?.timeStamp).format(
            'MMM DD, YYYY hh:mm a'
          )}
        </div>
        {meta?.sync &&
        meta?.sync?.length &&
        meta?.sync[0].syncStatus === 'Success' ? (
          <div style={{ padding: '5px 0', display: 'flex' }}>
            <SyncIcon /> Sync'd w {meta?.sync[0].syncSource}
          </div>
        ) : null}
      </CreatedByContainer>
    </TourComponent>
  );
};

const TourBookingSuccessful = props => {
  const { type, customerName, meta } = props.props;
  return (
    <>
      <TourBookingSuccessfulEvent props={props} />
      <SenderInitial>
        {type === 'incoming'
          ? customerName
            ? customerName[0]
            : 'C'
          : meta?.agentName
            ? meta?.agentName[0]
            : 'K'}
      </SenderInitial>
    </>
  );
};

export default TourBookingSuccessful;
